var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('KZPrice',{attrs:{"price":_vm.price,"color":_vm.color}}),_c('KZFrame',{attrs:{"sum":_vm.sum,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }